// extracted by mini-css-extract-plugin
export var boxItems = "_6s-1";
export var boxItemsLg = "_6s-2";
export var button = "_6s-7";
export var buttonHoverless = "_6s-9";
export var buttonLg = "_6s-8";
export var filterGroupBox = "_6s-0";
export var icon = "_6s-3";
export var iconSecondary = "_6s-6";
export var iconWrapper = "_6s-4";
export var iconWrapperLg = "_6s-5";
export var truncatedLabel = "_6s-a";